import { Dictionary } from "@insite/client-framework/Common/Types";
import { createHandlerChainRunnerOptionalParameter, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import { isLoadMore } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import cloneDeep from "lodash/cloneDeep";
import qs from "qs";

const knownFilterKeys = new Set([
    "criteria",
    // HasPagingParameters
    "page",
    "pageSize",
    "defaultPageSize",
    "sort",
    // ProductFilters
    "pageCategoryId",
    "pageBrandId",
    "pageProductLineId",
    "query",
    "includeSuggestions",
    "stockedItemsOnly",
    "previouslyPurchasedProducts",
    "searchWithinQueries",
    "brandIds",
    "productLineIds",
    "priceFilters",
    "attributeValueIds",
    "categoryId",
    "expand",
    "additionalExpands",
]);

type HandlerType = HandlerWithResult<{}, string>;

export const SetFilterQuery: HandlerType = props => {
    const queryObject = cloneDeep(props.getState().pages.productList.productFilters);
    delete queryObject.expand;
    delete queryObject.pageCategoryId;
    delete queryObject.pageProductLineId;
    delete queryObject.pageBrandId;

    if (isLoadMore(props.getState())) {
        delete queryObject.pageSize;
    }

    if (queryObject.searchWithinQueries && queryObject.searchWithinQueries.length > 1) {
        // Search within Queries need to split by space, to use for ElasticSearch
        queryObject.searchWithinQueries = [queryObject.searchWithinQueries.join(" ")];
    }

    const currentSearch = typeof window !== "undefined" ? window.location.search : "";
    const currentParams = qs.parse(currentSearch, { ignoreQueryPrefix: true });
    const thirdPartyParams: Dictionary<unknown> = {};
    for (const key of Object.keys(currentParams)) {
        if (!knownFilterKeys.has(key)) {
            thirdPartyParams[key] = currentParams[key];
        }
    }

    const mergedQuery = { ...queryObject, ...thirdPartyParams };
    props.result = qs.stringify(mergedQuery, { arrayFormat: "comma", skipNulls: true });
};

export const DispatchSetFilterQuery: HandlerType = props => {
    props.dispatch({
        type: "Pages/ProductList/SetFilterQuery",
        result: props.result,
    });
};

export const chain = [SetFilterQuery, DispatchSetFilterQuery];

const setFilterQuery = createHandlerChainRunnerOptionalParameter(chain, {}, "SetFilterQuery");
export default setFilterQuery;
